import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@mui/material";
import { formatDate } from "../../utils";
import { t } from "i18next"; // Import t function for translation

const OrderListItem = (props) => {
  const { data } = props || {};

  return (
    <div className="order-list-item">
      <Link to={`/order-detail/${data?.id}`}>
        <div className="order-list-item-header d-flex justify-content-between align-items-center">
          <div className="order-list-item-header-title">
            {t("orderListItem.orderedTitle")}: {formatDate(data?.createAt)}
          </div>
          <div className="order-list-item-header-price">
            {data?.points} {t("orderListItem.pointsTitle")}
          </div>
        </div>
        <div className="order-list-item-context">
          {t("orderListItem.receiptNumberTitle")}: {data?.receiptNumber}
        </div>
        <div className="order-list-item-button">
          <Button>{t("orderListItem.orderDetailButtonText")}</Button>
        </div>
      </Link>
    </div>
  );
};

export default OrderListItem;
